// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ProviderTiersRouteImport } from './routes/provider-tiers'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PlaygroundRouteImport } from './routes/playground'
import { Route as ModelsRouteImport } from './routes/models'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as DataProcessingRouteImport } from './routes/data-processing'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as BlogsRouteImport } from './routes/blogs'
import { Route as AgentsRouteImport } from './routes/agents'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PlaygroundThreadIdRouteImport } from './routes/playground.$threadId'
import { Route as ModelsIndexRouteImport } from './routes/models.index'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DocsSplatRouteImport } from './routes/docs/$'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardProfileRouteImport } from './routes/dashboard/profile'
import { Route as DashboardModelsRouteImport } from './routes/dashboard/models'
import { Route as DashboardGenerationsRouteImport } from './routes/dashboard/generations'
import { Route as BlogsIndexRouteImport } from './routes/blogs/index'
import { Route as BlogsSlugRouteImport } from './routes/blogs/$slug'
import { Route as AdminBaseRequestTrackingRouteImport } from './routes/admin/base-request-tracking'
import { Route as ModelsTypeSplatRouteImport } from './routes/models.$type.$'
import { Route as DocsApiReferenceGenerationsRouteImport } from './routes/docs/api-reference/generations'
import { Route as DocsApiReferenceGenerationTypesRouteImport } from './routes/docs/api-reference/generation-types'
import { Route as DocsApiReferenceGenerationParametersRouteImport } from './routes/docs/api-reference/generation-parameters'
import { Route as DocsApiReferenceGenerationModelsRouteImport } from './routes/docs/api-reference/generation-models'
import { Route as DashboardWorkspacesIdRouteImport } from './routes/dashboard/workspaces/$id'
import { Route as AdminPostsSlugRouteImport } from './routes/admin/posts/$slug'

const DashboardIndexLazyRouteImport = createFileRoute('/dashboard/')()
const DashboardWalletLazyRouteImport = createFileRoute('/dashboard/wallet')()
const DashboardUsageLazyRouteImport = createFileRoute('/dashboard/usage')()
const DashboardReferralLazyRouteImport = createFileRoute('/dashboard/referral')()
const DashboardChangePasswordLazyRouteImport = createFileRoute('/dashboard/change-password')()
const DashboardAgentsLazyRouteImport = createFileRoute('/dashboard/agents')()
const AdminIndexLazyRouteImport = createFileRoute('/admin/')()
const AdminUsersLazyRouteImport = createFileRoute('/admin/users')()
const AdminSystemNoticesLazyRouteImport = createFileRoute('/admin/system-notices')()
const AdminSystemMonitoringLazyRouteImport = createFileRoute('/admin/system-monitoring')()
const AdminRequestTrackingLazyRouteImport = createFileRoute('/admin/request-tracking')()
const AdminRedeemCodeLazyRouteImport = createFileRoute('/admin/redeem-code')()
const AdminProvidersLazyRouteImport = createFileRoute('/admin/providers')()
const AdminModelsManagementLazyRouteImport = createFileRoute('/admin/models-management')()
const AdminEmailTemplatesLazyRouteImport = createFileRoute('/admin/email-templates')()
const AdminEmailCampaignsLazyRouteImport = createFileRoute('/admin/email-campaigns')()
const AdminContentSourcesLazyRouteImport = createFileRoute('/admin/content-sources')()
const AdminCircuitBreakerLazyRouteImport = createFileRoute('/admin/circuit-breaker')()
const AdminCampaignsLazyRouteImport = createFileRoute('/admin/campaigns')()
const AdminAnalyzerLazyRouteImport = createFileRoute('/admin/analyzer')()
const DashboardWorkspacesIndexLazyRouteImport = createFileRoute('/dashboard/workspaces/')()
const DashboardAgentsIndexLazyRouteImport = createFileRoute('/dashboard/agents/')()
const DashboardAgentsNewLazyRouteImport = createFileRoute('/dashboard/agents/new')()
const AdminPostsIndexLazyRouteImport = createFileRoute('/admin/posts/')()
const AdminPostsNewLazyRouteImport = createFileRoute('/admin/posts/new')()
const DashboardAgentsStackIdIndexLazyRouteImport = createFileRoute('/dashboard/agents/$stackId/')()
const DashboardAgentsStackIdEditLazyRouteImport = createFileRoute('/dashboard/agents/$stackId/edit')()

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const StatusRoute = StatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const ProviderTiersRoute = ProviderTiersRouteImport.update({
            id: '/provider-tiers',path: '/provider-tiers',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PlaygroundRoute = PlaygroundRouteImport.update({
            id: '/playground',path: '/playground',getParentRoute: () => rootRouteImport
          })
const ModelsRoute = ModelsRouteImport.update({
            id: '/models',path: '/models',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const DataProcessingRoute = DataProcessingRouteImport.update({
            id: '/data-processing',path: '/data-processing',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/dashboard.lazy').then((d) => d.Route))
const ChangelogRoute = ChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => rootRouteImport
          })
const BlogsRoute = BlogsRouteImport.update({
            id: '/blogs',path: '/blogs',getParentRoute: () => rootRouteImport
          })
const AgentsRoute = AgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/admin.lazy').then((d) => d.Route))
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
            id: '/accept-invitation',path: '/accept-invitation',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PlaygroundThreadIdRoute = PlaygroundThreadIdRouteImport.update({
            id: '/$threadId',path: '/$threadId',getParentRoute: () => PlaygroundRoute
          })
const ModelsIndexRoute = ModelsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ModelsRoute
          })
const DocsIndexRoute = DocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DocsRoute
          })
const DocsSplatRoute = DocsSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => DocsRoute
          })
const DashboardIndexLazyRoute = DashboardIndexLazyRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          }).lazy(() => import('./routes/dashboard/index.lazy').then((d) => d.Route))
const DashboardWalletLazyRoute = DashboardWalletLazyRouteImport.update({
            id: '/wallet',path: '/wallet',getParentRoute: () => DashboardRoute
          }).lazy(() => import('./routes/dashboard/wallet.lazy').then((d) => d.Route))
const DashboardUsageLazyRoute = DashboardUsageLazyRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => DashboardRoute
          }).lazy(() => import('./routes/dashboard/usage.lazy').then((d) => d.Route))
const DashboardReferralLazyRoute = DashboardReferralLazyRouteImport.update({
            id: '/referral',path: '/referral',getParentRoute: () => DashboardRoute
          }).lazy(() => import('./routes/dashboard/referral.lazy').then((d) => d.Route))
const DashboardChangePasswordLazyRoute = DashboardChangePasswordLazyRouteImport.update({
            id: '/change-password',path: '/change-password',getParentRoute: () => DashboardRoute
          }).lazy(() => import('./routes/dashboard/change-password.lazy').then((d) => d.Route))
const DashboardAgentsLazyRoute = DashboardAgentsLazyRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => DashboardRoute
          }).lazy(() => import('./routes/dashboard/agents.lazy').then((d) => d.Route))
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardRoute
          }).lazy(() => import('./routes/dashboard/settings.lazy').then((d) => d.Route))
const DashboardProfileRoute = DashboardProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => DashboardRoute
          })
const DashboardModelsRoute = DashboardModelsRouteImport.update({
            id: '/models',path: '/models',getParentRoute: () => DashboardRoute
          })
const DashboardGenerationsRoute = DashboardGenerationsRouteImport.update({
            id: '/generations',path: '/generations',getParentRoute: () => DashboardRoute
          }).lazy(() => import('./routes/dashboard/generations.lazy').then((d) => d.Route))
const BlogsIndexRoute = BlogsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogsRoute
          })
const BlogsSlugRoute = BlogsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogsRoute
          })
const AdminIndexLazyRoute = AdminIndexLazyRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/index.lazy').then((d) => d.Route))
const AdminUsersLazyRoute = AdminUsersLazyRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/users.lazy').then((d) => d.Route))
const AdminSystemNoticesLazyRoute = AdminSystemNoticesLazyRouteImport.update({
            id: '/system-notices',path: '/system-notices',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/system-notices.lazy').then((d) => d.Route))
const AdminSystemMonitoringLazyRoute = AdminSystemMonitoringLazyRouteImport.update({
            id: '/system-monitoring',path: '/system-monitoring',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/system-monitoring.lazy').then((d) => d.Route))
const AdminRequestTrackingLazyRoute = AdminRequestTrackingLazyRouteImport.update({
            id: '/request-tracking',path: '/request-tracking',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/request-tracking.lazy').then((d) => d.Route))
const AdminRedeemCodeLazyRoute = AdminRedeemCodeLazyRouteImport.update({
            id: '/redeem-code',path: '/redeem-code',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/redeem-code.lazy').then((d) => d.Route))
const AdminProvidersLazyRoute = AdminProvidersLazyRouteImport.update({
            id: '/providers',path: '/providers',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/providers.lazy').then((d) => d.Route))
const AdminModelsManagementLazyRoute = AdminModelsManagementLazyRouteImport.update({
            id: '/models-management',path: '/models-management',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/models-management.lazy').then((d) => d.Route))
const AdminEmailTemplatesLazyRoute = AdminEmailTemplatesLazyRouteImport.update({
            id: '/email-templates',path: '/email-templates',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/email-templates.lazy').then((d) => d.Route))
const AdminEmailCampaignsLazyRoute = AdminEmailCampaignsLazyRouteImport.update({
            id: '/email-campaigns',path: '/email-campaigns',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/email-campaigns.lazy').then((d) => d.Route))
const AdminContentSourcesLazyRoute = AdminContentSourcesLazyRouteImport.update({
            id: '/content-sources',path: '/content-sources',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/content-sources.lazy').then((d) => d.Route))
const AdminCircuitBreakerLazyRoute = AdminCircuitBreakerLazyRouteImport.update({
            id: '/circuit-breaker',path: '/circuit-breaker',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/circuit-breaker.lazy').then((d) => d.Route))
const AdminCampaignsLazyRoute = AdminCampaignsLazyRouteImport.update({
            id: '/campaigns',path: '/campaigns',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/campaigns.lazy').then((d) => d.Route))
const AdminAnalyzerLazyRoute = AdminAnalyzerLazyRouteImport.update({
            id: '/analyzer',path: '/analyzer',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/analyzer.lazy').then((d) => d.Route))
const AdminBaseRequestTrackingRoute = AdminBaseRequestTrackingRouteImport.update({
            id: '/base-request-tracking',path: '/base-request-tracking',getParentRoute: () => AdminRoute
          })
const ModelsTypeSplatRoute = ModelsTypeSplatRouteImport.update({
            id: '/$type/$',path: '/$type/$',getParentRoute: () => ModelsRoute
          })
const DocsApiReferenceGenerationsRoute = DocsApiReferenceGenerationsRouteImport.update({
            id: '/api-reference/generations',path: '/api-reference/generations',getParentRoute: () => DocsRoute
          })
const DocsApiReferenceGenerationTypesRoute = DocsApiReferenceGenerationTypesRouteImport.update({
            id: '/api-reference/generation-types',path: '/api-reference/generation-types',getParentRoute: () => DocsRoute
          })
const DocsApiReferenceGenerationParametersRoute = DocsApiReferenceGenerationParametersRouteImport.update({
            id: '/api-reference/generation-parameters',path: '/api-reference/generation-parameters',getParentRoute: () => DocsRoute
          })
const DocsApiReferenceGenerationModelsRoute = DocsApiReferenceGenerationModelsRouteImport.update({
            id: '/api-reference/generation-models',path: '/api-reference/generation-models',getParentRoute: () => DocsRoute
          })
const DashboardWorkspacesIndexLazyRoute = DashboardWorkspacesIndexLazyRouteImport.update({
            id: '/workspaces/',path: '/workspaces/',getParentRoute: () => DashboardRoute
          }).lazy(() => import('./routes/dashboard/workspaces/index.lazy').then((d) => d.Route))
const DashboardWorkspacesIdRoute = DashboardWorkspacesIdRouteImport.update({
            id: '/workspaces/$id',path: '/workspaces/$id',getParentRoute: () => DashboardRoute
          }).lazy(() => import('./routes/dashboard/workspaces/$id.lazy').then((d) => d.Route))
const DashboardAgentsIndexLazyRoute = DashboardAgentsIndexLazyRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardAgentsLazyRoute
          }).lazy(() => import('./routes/dashboard/agents/index.lazy').then((d) => d.Route))
const DashboardAgentsNewLazyRoute = DashboardAgentsNewLazyRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => DashboardAgentsLazyRoute
          }).lazy(() => import('./routes/dashboard/agents/new.lazy').then((d) => d.Route))
const AdminPostsIndexLazyRoute = AdminPostsIndexLazyRouteImport.update({
            id: '/posts/',path: '/posts/',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/posts/index.lazy').then((d) => d.Route))
const AdminPostsNewLazyRoute = AdminPostsNewLazyRouteImport.update({
            id: '/posts/new',path: '/posts/new',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/posts/new.lazy').then((d) => d.Route))
const AdminPostsSlugRoute = AdminPostsSlugRouteImport.update({
            id: '/posts/$slug',path: '/posts/$slug',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin/posts/$slug.lazy').then((d) => d.Route))
const DashboardAgentsStackIdIndexLazyRoute = DashboardAgentsStackIdIndexLazyRouteImport.update({
            id: '/$stackId/',path: '/$stackId/',getParentRoute: () => DashboardAgentsLazyRoute
          }).lazy(() => import('./routes/dashboard/agents/$stackId/index.lazy').then((d) => d.Route))
const DashboardAgentsStackIdEditLazyRoute = DashboardAgentsStackIdEditLazyRouteImport.update({
            id: '/$stackId/edit',path: '/$stackId/edit',getParentRoute: () => DashboardAgentsLazyRoute
          }).lazy(() => import('./routes/dashboard/agents/$stackId/edit.lazy').then((d) => d.Route))





const AdminRouteChildren = {
  AdminBaseRequestTrackingRoute: AdminBaseRequestTrackingRoute,AdminAnalyzerLazyRoute: AdminAnalyzerLazyRoute,AdminCampaignsLazyRoute: AdminCampaignsLazyRoute,AdminCircuitBreakerLazyRoute: AdminCircuitBreakerLazyRoute,AdminContentSourcesLazyRoute: AdminContentSourcesLazyRoute,AdminEmailCampaignsLazyRoute: AdminEmailCampaignsLazyRoute,AdminEmailTemplatesLazyRoute: AdminEmailTemplatesLazyRoute,AdminModelsManagementLazyRoute: AdminModelsManagementLazyRoute,AdminProvidersLazyRoute: AdminProvidersLazyRoute,AdminRedeemCodeLazyRoute: AdminRedeemCodeLazyRoute,AdminRequestTrackingLazyRoute: AdminRequestTrackingLazyRoute,AdminSystemMonitoringLazyRoute: AdminSystemMonitoringLazyRoute,AdminSystemNoticesLazyRoute: AdminSystemNoticesLazyRoute,AdminUsersLazyRoute: AdminUsersLazyRoute,AdminIndexLazyRoute: AdminIndexLazyRoute,AdminPostsSlugRoute: AdminPostsSlugRoute,AdminPostsNewLazyRoute: AdminPostsNewLazyRoute,AdminPostsIndexLazyRoute: AdminPostsIndexLazyRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const BlogsRouteChildren = {
  BlogsSlugRoute: BlogsSlugRoute,BlogsIndexRoute: BlogsIndexRoute
}

const BlogsRouteWithChildren = BlogsRoute._addFileChildren(BlogsRouteChildren)




const DashboardAgentsLazyRouteChildren = {
  DashboardAgentsNewLazyRoute: DashboardAgentsNewLazyRoute,DashboardAgentsIndexLazyRoute: DashboardAgentsIndexLazyRoute,DashboardAgentsStackIdEditLazyRoute: DashboardAgentsStackIdEditLazyRoute,DashboardAgentsStackIdIndexLazyRoute: DashboardAgentsStackIdIndexLazyRoute
}

const DashboardAgentsLazyRouteWithChildren = DashboardAgentsLazyRoute._addFileChildren(DashboardAgentsLazyRouteChildren)



const DashboardRouteChildren = {
  DashboardGenerationsRoute: DashboardGenerationsRoute,DashboardModelsRoute: DashboardModelsRoute,DashboardProfileRoute: DashboardProfileRoute,DashboardSettingsRoute: DashboardSettingsRoute,DashboardAgentsLazyRoute: DashboardAgentsLazyRouteWithChildren,DashboardChangePasswordLazyRoute: DashboardChangePasswordLazyRoute,DashboardReferralLazyRoute: DashboardReferralLazyRoute,DashboardUsageLazyRoute: DashboardUsageLazyRoute,DashboardWalletLazyRoute: DashboardWalletLazyRoute,DashboardIndexLazyRoute: DashboardIndexLazyRoute,DashboardWorkspacesIdRoute: DashboardWorkspacesIdRoute,DashboardWorkspacesIndexLazyRoute: DashboardWorkspacesIndexLazyRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)




const DocsRouteChildren = {
  DocsSplatRoute: DocsSplatRoute,DocsIndexRoute: DocsIndexRoute,DocsApiReferenceGenerationModelsRoute: DocsApiReferenceGenerationModelsRoute,DocsApiReferenceGenerationParametersRoute: DocsApiReferenceGenerationParametersRoute,DocsApiReferenceGenerationTypesRoute: DocsApiReferenceGenerationTypesRoute,DocsApiReferenceGenerationsRoute: DocsApiReferenceGenerationsRoute
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)




const ModelsRouteChildren = {
  ModelsIndexRoute: ModelsIndexRoute,ModelsTypeSplatRoute: ModelsTypeSplatRoute
}

const ModelsRouteWithChildren = ModelsRoute._addFileChildren(ModelsRouteChildren)




const PlaygroundRouteChildren = {
  PlaygroundThreadIdRoute: PlaygroundThreadIdRoute
}

const PlaygroundRouteWithChildren = PlaygroundRoute._addFileChildren(PlaygroundRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AcceptInvitationRoute: AcceptInvitationRoute,AdminRoute: AdminRouteWithChildren,AgentsRoute: AgentsRoute,BlogsRoute: BlogsRouteWithChildren,ChangelogRoute: ChangelogRoute,DashboardRoute: DashboardRouteWithChildren,DataProcessingRoute: DataProcessingRoute,DocsRoute: DocsRouteWithChildren,ForgotPasswordRoute: ForgotPasswordRoute,ModelsRoute: ModelsRouteWithChildren,PlaygroundRoute: PlaygroundRouteWithChildren,PrivacyRoute: PrivacyRoute,ProviderTiersRoute: ProviderTiersRoute,ResetPasswordRoute: ResetPasswordRoute,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,StatusRoute: StatusRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)